interface LogoProps {
  size?: number;
  withText?: boolean;
  textColor?: string;
  subtitleColor?: string;
}

export function Logo({
  size = 28,
  withText = true,
  textColor = '#0f1e3d',
  subtitleColor = 'rgba(15,30,61,.55)',
}: LogoProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <img
        src="/typer.png"
        width={size}
        height={size}
        style={{ borderRadius: size * 0.5, display: 'block', flexShrink: 0 }}
        alt="WC Typer"
      />
      {withText && (
        <div style={{ textAlign: 'left', lineHeight: 1 }}>
          <div
            style={{
              fontFamily: 'Fraunces, serif',
              fontWeight: 700,
              fontSize: 20,
              color: textColor,
              letterSpacing: '-0.015em',
              lineHeight: 1,
              whiteSpace: 'nowrap',
            }}
          >
            WC Typer
          </div>
          <div
            style={{
              fontSize: 12,
              color: subtitleColor,
              marginTop: 4,
              lineHeight: 1,
              letterSpacing: '0.04em',
              fontWeight: 500,
              whiteSpace: 'nowrap',
            }}
          >
            World Cup
          </div>
        </div>
      )}
    </div>
  );
}
